const DATE_FORMAT = 'MM/DD/YYYY';

export default DATE_FORMAT;
